// @ts-check
import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import DefaultOption from 'react-select/lib/Option';
import _ from 'lodash';
import api from 'utils/api';
import { Async as AsyncSelect } from 'react-select';

const fetchOptions = _.debounce((input, setOptions) => {
  api
    .get('/shared/api/providers', { params: { search_term: input } })
    .then(response => setOptions(null, { options: response.data.providers }));
  return null;
}, 350);

/**
 * @param {string[]} specialtyNames
 * @returns {JSX.Element}
 */
const specialties = specialtyNames => {
  if (specialtyNames.length >= 4) {
    return (
      <span>{` (${specialtyNames.length} specialties including ${specialtyNames
        .slice(0, 3)
        .join(', ')})`}</span>
    );
  } else if (specialtyNames.length >= 1) {
    return <span>{` (${specialtyNames.join(', ')})`}</span>;
  }
  return null;
};

/**
 * @param {string[]} stateNames
 * @returns {string}
 */
const states = stateNames => {
  if (stateNames.length >= 4) {
    return `${stateNames.length} states including ${stateNames.slice(0, 3).join(', ')}`;
  } else if (stateNames.length >= 1) {
    return stateNames.join(', ');
  }
  return '';
};

/** @typedef {{
  option: {
    name: string,
    organizationNames: string[],
    stateNames: string[],
    specialtyNames: string[]
  }
}} ProviderOptionPropsType */

// NB: This can't be a stateless functional component, because it's given a ref
/** @augments { Component<ProviderOptionPropsType, {}> } */
class ProviderOption extends Component {
  // eslint-disable-line react/prefer-stateless-function
  render() {
    const { option } = this.props;
    return (
      <DefaultOption {...this.props}>
        <div>
          <span style={{ fontWeight: 700 }}>{option.name}</span>
          <i style={{ fontSize: 10 }}>{specialties(option.specialtyNames)}</i>
        </div>
        <p style={{ fontSize: 10, fontStyle: 'italic' }}>
          {`${option.organizationNames.join(', ')} - ${states(option.stateNames)}`}
        </p>
      </DefaultOption>
    );
  }
}

const trueFunc = () => true;

/** @typedef {{
  value: {
    id: string,
    name: string,
    score?: number,
    stateNames: string[],
    specialtyNames: string[]
  } | "",
  onChange: any,
  className?: string,
  loadOptions?: (input: string, setOptions: any) => any;
  placeholder?: string;
}} ProviderSelectionPropsType */

/** @type { React.FC<ProviderSelectionPropsType >} */
const ProviderSelection = ({ value, onChange, className, loadOptions = fetchOptions, placeholder = "Search..." }) => (
  <AsyncSelect
    autoload={false}
    loadOptions={loadOptions}
    valueKey="id"
    labelKey="name"
    value={value}
    onChange={onChange}
    className={className}
    optionComponent={ProviderOption}
    filterOption={trueFunc}
    placeholder={placeholder}
  />
);

ProviderSelection.displayName = 'ProviderSelection';

ProviderSelection.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      score: PropTypes.number,
      stateNames: PropTypes.array.isRequired,
      specialtyNames: PropTypes.array.isRequired,
    }),
  ]),
  onChange: PropTypes.func,
};

export default ProviderSelection;
